import React from "react";
import { connect } from "react-redux";
import api from "../../../../../api";
import "../../../../Grid/grid.css";
import { Segment, Table, Message, Item, Dropdown } from "semantic-ui-react";
import { Form, TextArea, Checkbox } from "formsy-semantic-ui-react";
import { DatatableTable } from "./DatatableTable";
import { DatatableFilter } from "./DatatableFilter";
import DialogBoxDetail from "./DialogBoxDetail";
import { DatatableRow } from "./DatatableRow";
import utilFunc from "../../../../../util_funs";
import { selectIsPLGAccount } from "../../../../../store/userSelectors";

const tableHeader = [
  {
    title: "Actions",
    width: "1",
    sort: "",
  },
  {
    title: "Notification Type",
    width: "2",
    sort: "",
  },
  {
    title: "Name",
    width: "2",
    sort: "",
  },
  {
    title: "Email/Phone",
    width: "3",
    sort: "",
  },
  {
    title: "Notify via",
    width: "2",
    sort: "",
  },
  {
    title: "Unique Identifier",
    width: "2",
    sort: "",
  }
];
const queryParams = ["_limit", "_order", "_sort", "q", "_page"];
class DatatableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lists: [],
      _sort: "user_id",
      _page: 1,
      _order: "desc",
      _limit: 10,
      q: "",
      totalCount: 0,
      loading: false,
      modalstatus: false,
      modaltitle: null,
      modalbuttonmsg: {},
      modalType: null,
      datatableHeader: null,
      datatableRows: null,
      modalErrorMsg: false,
      modalErrorMsgLegacy: false,
      modalstatusAddEdit: false,
      modaldata: {},
      modalFormLoader: false,
      selectedOptions: [],
      accessModuleList: [],
      modalstatusNotiAandMisc: false,
      modalstatusNotiAandMiscData: {},
      ISDrenderOption1: [],
      ISDrenderOption2: [],
      notiAndSettingmodalData: {},
      loadNow: false,
      currentChecked: [],
      currentExpanded: [],
      hipaaLoginEmailList: [],
      hipaaLoginPhoneList: [],
      notifyvia: {
        email: true,
        phonecall: false,
        text: false
      },
      error: {},
      messageDisplay: 'none',
      color: 'green',
      resMessage: '',
      buttonDisable: false,
      modalFooter: true,
      selectedBranch: ['anybranch'],
      selectedAnswers:[],
      voice_type: "voice",
      notifyviaError:false,
      notifyviaError1:false,
      ai_voice_type: this.props.ai_voice_type || 'inbound',
      outboundWorkspaces: [],
      outboundSelectedWorkspaces: [],
      outboundSelectedParsedFields: {},
      outboundSelectedValues: {},
    };
  }

  componentDidMount() {
    this.loadData({});

    // this.getAccessModules();
    // api.user
    //   .getProfile()
    //   .then((resp) => {
    //     if (resp.data && resp.data.data.profileDetails) {
    //       const remailCountryCodeArr = resp.data.data.remailCountryCodeArr;
    //       const defaultCountryCodeArr = resp.data.data.defaultCountryCodeArr;
    //       this.setState({ ISDrenderOption1: defaultCountryCodeArr });
    //       this.setState({ ISDrenderOption2: remailCountryCodeArr });
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  }

  componentDidUpdate(prevProps) {
    // If ai_voice_type prop changes, update state and reload data to prevent data mixing
    if (prevProps.ai_voice_type !== this.props.ai_voice_type) {
      const newAiVoiceType = this.props.ai_voice_type || 'inbound';
      this.setState({ ai_voice_type: newAiVoiceType }, () => {
        // Reload data with the new ai_voice_type to ensure correct filtering
        this.loadData({ _page: 1 });
      });
    }
  }

  static directionConverter(order) {
    if (order === "asc") {
      return "ascending";
    } else if (order === "desc") {
      return "descending";
    } else {
      return null;
    }
  }

  handleSort = (clickedColumn) => {
    const { _sort, _order } = this.state;

    let newOrder = _order === "asc" ? "desc" : "asc";
    if (_sort !== clickedColumn) {
      newOrder = "asc";
    }

    this.loadData({
      _sort: clickedColumn,
      _page: 1,
      _order: newOrder,
    });
  };

  onChangeLimit = (event, data) => {
    if (data.value !== this.state._limit) {
      this.loadData({ _limit: data.value, _page: 1 });
    }
  };

  onSubmitFilter = (filter) => {
    if (filter !== this.state.q) {
      this.loadData({ q: filter, _page: 1 });
    }
  };

  onChangePage = (event, data) => {
    const { activePage } = data;
    if (activePage !== this.state._page) {
      this.loadData({ _page: activePage });
    }
  };

  modalbuttofun = (data) => {
    if (data.modalType == "Delete") {
      this.onDeleteCompletedChatAction();
    }
    // if (data.modalType == 'Popup') {
    //   this.setState({
    //     modalstatus: false,
    //     modaltitle: '',
    //     modalmessage: '',
    //     modalbuttonmsg: {},
    //     modalType: ''
    //   });
    // }
  };

  branchOptionList = () => {
    const firstIndex = {
      key: 'anybranch',
      text: 'Any branch',
      value: 'anybranch'
    };
    const key = 'branch_name';
    
    // Handle outbound workspaces if available
    if (this.state.ai_voice_type === 'outbound' && this.state.outboundWorkspaces) {
      let list = this.state.outboundWorkspaces.map((ws) => {
        return {
          key: String(ws.id),
          text: ws.name,
          value: String(ws.id)
        }
      });
      list.splice(0, 0, firstIndex);
      return list;
    }
    
    // Handle inbound branches (existing logic)
    if (!this.state.workspaceBranches || this.state.workspaceBranches.length === 0) {
      return [firstIndex];
    }
    
    let  filterlist = [...new Map(this.state.workspaceBranches.map(item =>
      [item[key], item])).values()];
    let list = filterlist.map((key, index) => {
      return {
        key: key.branch_id,
        text: key.branch_name,
        value: key.branch_id
      }
    });
    list.splice(0, 0, firstIndex);
    return list;
  }

  branchansList=(ans)=>{
       let parsed=this.state.parsed_values;
       let opts=parsed.filter((val)=>val?.key===ans[0]?.key);
       let list=opts[0]?.val.map((item)=>{
        return {
         key:ans[0].key,
         text:item,
         value:item
        }
       });
       return list;
  }

  /**
   * Handles branch/workspace selection changes
   * For outbound: updates workspace rules based on selected workspaces
   * For inbound: updates branch selection
   */
  handleBranchSelection = async (e, d) => {
    const memberData = this.state.modaldata;
    memberData.voice_brances = d.value;
    const isOutbound = this.state.ai_voice_type === 'outbound';
    
    if (isOutbound) {
      // For outbound, update workspace rules based on selected workspaces
      const selectedWorkspaceIds = d.value.filter(workspaceId => workspaceId !== 'anybranch');
      
      // Create or update workspace rules
      const validRules = await this.createOrUpdateOutboundWorkspaceRules(selectedWorkspaceIds);
      
      // Merge with existing rules in modaldata
      const existingOutboundRules = memberData.outboundRules || [];
      const mergedRules = this.mergeOutboundRulesWithModalData(validRules, existingOutboundRules);
      
      memberData.outboundRules = mergedRules;
      memberData.outboundWorkspaceRules = validRules;
      
      this.setState({ 
        selectedBranch: d.value, 
        modaldata: memberData,
        outboundWorkspaceRules: validRules
      }, async () => {
        // Load parsed fields for selected workspaces
        if (d.value && d.value.length > 0) {
          await this.branchOptionValues(d.value);
        } else {
          this.setState({
            modalmessage: this.memberEditBody()
          });
        }
      });
    } else {
      // Inbound logic (existing)
      this.setState({ selectedBranch: d.value, modaldata: memberData}, () => {
        if((this.state.voice_type=="Turbo" || this.state.ai_voice_type === 'outbound') && this.state.selectedBranch){
          this.branchOptionValues(this.state.selectedBranch);
        }
      });
    }
  }
  /**
   * Helper function to collect all key_indices from rules and state
   * @returns {Map} Map of field keys to their values
   */
  collectAllKeyIndices = () => {
    const allKeyIndicesMap = new Map();
    
    // Collect from existing rules in modaldata
    if (this.state.modaldata.outboundRules && this.state.modaldata.outboundRules.length > 0) {
      this.state.modaldata.outboundRules.forEach(rule => {
        if (rule.key_indices && Array.isArray(rule.key_indices)) {
          rule.key_indices.forEach(keyIndex => {
            if (keyIndex.key && keyIndex.values && Array.isArray(keyIndex.values) && keyIndex.values.length > 0) {
              allKeyIndicesMap.set(keyIndex.key, keyIndex.values);
            }
          });
        }
      });
    }
    
    // Also check state key_indices
    if (this.state.key_indices && Array.isArray(this.state.key_indices)) {
      this.state.key_indices.forEach(keyIndex => {
        if (keyIndex.key && keyIndex.values && Array.isArray(keyIndex.values) && keyIndex.values.length > 0) {
          if (!allKeyIndicesMap.has(keyIndex.key)) {
            allKeyIndicesMap.set(keyIndex.key, keyIndex.values);
          }
        }
      });
    }
    
    return allKeyIndicesMap;
  };

  /**
   * Helper function to load parsed fields for a workspace in branchOptionValues
   * @param {string} workspaceIdString - The workspace ID as a string
   * @param {Map} allKeyIndicesMap - Map of all collected key_indices
   * @returns {Promise<Array>} Promise resolving to array of parsed fields in form format
   */
  loadParsedFieldsForWorkspaceInBranchOptions = async (workspaceIdString, allKeyIndicesMap) => {
    try {
      let parsedFields = [];
      
      // Check if we have key_indices for this workspace in rules
      const rule = this.state.modaldata.outbound_rules?.find(rule => 
        String(rule.workspace_id) === workspaceIdString
      );
      
      if (rule && rule.key_indices && rule.key_indices.length > 0) {
        // Use key_indices from rule - ensures we show the same fields that were available during creation
        parsedFields = rule.key_indices
          .filter(keyIndex => keyIndex.key && keyIndex.values && Array.isArray(keyIndex.values) && keyIndex.values.length > 0)
          .map(keyIndex => ({
            key: keyIndex.key,
            values: keyIndex.values || []
          }));
      } else if (allKeyIndicesMap.size > 0) {
        // Use collected key_indices if rule doesn't have them
        allKeyIndicesMap.forEach((values, key) => {
          parsedFields.push({
            key: key,
            values: values
          });
        });
      } else {
        // Fallback: Check cache first, then fetch from API
        parsedFields = await this.fetchParsedFieldsForWorkspace(workspaceIdString, this.state.outboundParsedCache);
        
        // Update cache in state if new data was fetched
        if (parsedFields.length > 0 && !this.state.outboundParsedCache[workspaceIdString]) {
          const updatedCache = {...this.state.outboundParsedCache};
          updatedCache[workspaceIdString] = parsedFields;
          this.setState({ outboundParsedCache: updatedCache });
        }
      }
      
      // Convert parsed fields to the format expected by the form
      return parsedFields.map(field => ({
        key: field.key,
        val: field.values || []
      }));
    } catch (error) {
      console.error('Error loading parsed fields for workspace:', error);
      return [];
    }
  };

  /**
   * Loads branch option values for selected workspaces/branches
   * For outbound: loads parsed fields from selected workspaces
   * For inbound: loads parsed values from selected branches
   */
  branchOptionValues = async (list) => {
    const isOutbound = this.state.ai_voice_type === 'outbound';
    
    if (isOutbound) {
      // For outbound, load parsed fields for selected workspaces
      let values = [];
      let savedValues = this.state.modaldata.branch_values ? this.state.modaldata.branch_values : [];
      
      if (list.length > 0) {
        const filteredList = list.filter(workspaceId => workspaceId !== 'anybranch' && workspaceId !== 'Any branch');
        
        // Collect all key_indices from rules and state
        const allKeyIndicesMap = this.collectAllKeyIndices();
        
        // Load parsed fields for each selected workspace
        const workspaceParsedFields = await Promise.all(
          filteredList.map(workspaceId => 
            this.loadParsedFieldsForWorkspaceInBranchOptions(String(workspaceId), allKeyIndicesMap)
          )
        );
        
        // Flatten and deduplicate parsed fields
        const allParsedFields = workspaceParsedFields.flat();
        const uniqueParsedFields = [];
        allParsedFields.forEach(field => {
          const existing = uniqueParsedFields.find(parsedField => parsedField.key === field.key);
          if (!existing) {
            uniqueParsedFields.push(field);
          }
        });
        
        values = uniqueParsedFields.map(field => [field]);
        
        // Filter saved values to only include those for selected workspaces
        if (values.length && savedValues.length) {
          savedValues = savedValues.filter(savedValue => {
            return values.some(value => savedValue.key === value[0]?.key);
          });
        } else if (values.length === 0) {
          savedValues = [];
        }
      } else {
        savedValues = [];
      }
      
      const modaldata = this.state.modaldata;
      modaldata.branch_values = savedValues;
      modaldata.selectedBranchValues = values;
      
      // Update parsed_values for the form
      const parsedValues = values.map(value => value[0]).filter(value => value);
      
      this.setState({
        modaldata: modaldata,
        parsed_values: parsedValues
      }, () => {
        this.setState({ modalmessage: this.memberEditBody() });
      });
    } else {
      // Inbound logic (existing)
      let vals=[];
      if(list.length > 0) {
        list=list.filter((val)=>val!=='anybranch');
         vals=list.map((branch,i)=>{
              if(branch!=='anybranch' && branch!=='Any branch'){
                let s=this.state.parsed_values.filter((vall,i,arr)=>{
                    return vall['key']==branch;
                });
               return  s;
              }else{
                return '';
              }
        });
      }
      let savedvlas=this.state.modaldata.branch_values ? this.state.modaldata.branch_values:[];
      if(vals.length===0){
         savedvlas=[];      
      }
      if(vals.length && savedvlas.length){
        let newans=savedvlas.filter((val,i)=>{
              let j=vals.findIndex((val1)=>{
                  return val.key===  val1[0]?.key
              });
              if(j>=0){
                return true;
              }
        });
          savedvlas=newans;
      }
      let modaldata=this.state.modaldata;
      modaldata.branch_values=savedvlas;
      modaldata.selectedBranchValues=vals;
      this.setState({modaldata:modaldata},()=>{
        this.setState({modalmessage: this.memberEditBody()});
      });
    }
  }

  handleAnswerSelection=(e,d)=>{
    let values=this.state.modaldata?.branch_values;
    let search=values.findIndex((item)=>item?.key==d.name);
    if(search>-1){
       let find=values[search];
       find['values']=d.value;
       values[search]=find;
    }else{
      values.push({key:d.name,values:d.value});
    }
    let modl=this.state.modaldata;
    modl.branch_values=values;
    this.setState({modaldata:modl},()=>{
      this.setState({modalmessage: this.memberEditBody()});
    });
  }

  /**
   * Helper function to fetch outbound member data from API or fallback to list data
   * @param {string|number} memberId - The member ID to fetch
   * @returns {Promise<Object>} Promise resolving to member data object
   */
  fetchOutboundMemberData = async (memberId) => {
    try {
      const memberResponse = await api.manageUser.getOutboundNotificationMember({ 
        id: memberId
      });
      console.log('Outbound member API response:', memberResponse);
      
      if (memberResponse?.status && memberResponse.data) {
        return {...memberResponse.data};
      } else {
        // Fallback to list data if API fails
        console.warn('API response failed, using list data');
        const recordIndex = this.state.lists.findIndex((list) => list.id === memberId);
        return recordIndex !== -1 ? {...this.state.lists[recordIndex]} : {};
      }
    } catch (apiError) {
      console.warn('API call failed, using list data:', apiError);
      // Fallback to list data if API fails
      const recordIndex = this.state.lists.findIndex((list) => list.id === memberId);
      return recordIndex !== -1 ? {...this.state.lists[recordIndex]} : {};
    }
  };

  /**
   * Helper function to normalize member data for form compatibility
   * Handles email/phone parsing, country code mapping, and required field defaults
   * @param {Object} memberData - Raw member data from API
   * @returns {Object} Normalized member data object
   */
  normalizeOutboundMemberData = (memberData) => {
    const normalizedData = {...memberData};
    
    // Set ai_voice_type
    normalizedData.ai_voice_type = this.state.ai_voice_type;
    
    // Map isd_code to country_code for form compatibility
    if (normalizedData.isd_code && !normalizedData.country_code) {
      normalizedData.country_code = normalizedData.isd_code;
    }
    
    // Map phone_number to phone for form compatibility
    if (normalizedData.phone_number && !normalizedData.phone) {
      normalizedData.phone = normalizedData.phone_number;
    }
    
    // Parse email/phone if needed (handle formats like "email/phone")
    if (normalizedData.email && normalizedData.email.includes('/')) {
      const phoneEmail = normalizedData.email.split('/');
      normalizedData.email = phoneEmail[0];
      normalizedData.phone = phoneEmail[1];
    } else if (normalizedData.emailphone && normalizedData.emailphone.includes('/')) {
      const phoneEmail = normalizedData.emailphone.split('/');
      normalizedData.email = phoneEmail[0];
      normalizedData.phone = phoneEmail[1];
    }
    
    // Ensure phone is set if not already parsed
    if (!normalizedData.phone && normalizedData.emailphone && normalizedData.emailphone.includes('/')) {
      const parts = normalizedData.emailphone.split('/');
      if (parts.length > 1) {
        normalizedData.phone = parts[1];
      }
    }
    
    // Ensure all required fields are present with defaults
    if (!normalizedData.name) normalizedData.name = '';
    if (!normalizedData.email) normalizedData.email = '';
    if (!normalizedData.phone) normalizedData.phone = '';
    normalizedData.phone = this.phoneFormat(normalizedData.phone || '');
    if (!normalizedData.notification_type) normalizedData.notification_type = '1';
    if (!normalizedData.notify_via) normalizedData.notify_via = [];
    if (!normalizedData.user_notification_values) normalizedData.user_notification_values = '';
    
    return normalizedData;
  };

  /**
   * Helper function to parse notification preferences from member data
   * Maps 'phone' to 'phonecall' for form consistency
   * @param {Object} memberData - Member data object
   * @returns {Object} Object with email, phonecall, and text boolean flags
   */
  parseNotificationPreferencesFromMemberData = (memberData) => {
    const notificationPreferences = {
      email: false,
      phonecall: false,
      text: false
    };

    if (memberData.notify_via && Array.isArray(memberData.notify_via)) {
      memberData.notify_via.forEach((item) => {
        // Map 'phone' to 'phonecall' for consistency in form
        const mappedItem = item === 'phone' ? 'phonecall' : item;
        if (notificationPreferences.hasOwnProperty(mappedItem)) {
          notificationPreferences[mappedItem] = true;
        }
      });
      // Also update notify_via array to use 'phonecall' for form consistency
      memberData.notify_via = memberData.notify_via.map(item => item === 'phone' ? 'phonecall' : item);
    }
    
    return notificationPreferences;
  };

  /**
   * Helper function to fetch parsed fields for a workspace
   * Uses cache if available, otherwise fetches from API
   * @param {string} workspaceIdString - The workspace ID as a string
   * @param {Object} parsedCache - Current parsed fields cache
   * @returns {Promise<Array>} Promise resolving to array of parsed fields
   */
  fetchParsedFieldsForWorkspace = async (workspaceIdString, parsedCache) => {
    // Check cache first
    if (parsedCache[workspaceIdString]) {
      return parsedCache[workspaceIdString];
    }
    
    // If not in cache, fetch combined data and extract for this workspace
    try {
      const combinedResponse = await api.manageUser.getOutboundWorkspacesWithFields();
      if (combinedResponse?.status && Array.isArray(combinedResponse.data)) {
        // Find the workspace and get its parsed fields
        const workspace = combinedResponse.data.find(ws => String(ws.workspace_id) === workspaceIdString);
        const parsedFields = workspace?.parsed_fields || [];
        parsedCache[workspaceIdString] = parsedFields;
        return parsedFields;
      }
      return [];
    } catch (error) {
      console.error('Error fetching parsed fields:', error);
      return [];
    }
  };

  /**
   * Convert API outbound_rules to simplified format for DialogBoxIndividualNotifications
   * Matches the simple state structure: outboundSelectedWorkspaces, outboundSelectedParsedFields, outboundSelectedValues
   */
  convertOutboundRulesToSimplifiedFormat = (outboundRules) => {
    const outboundSelectedWorkspaces = [];
    const outboundSelectedParsedFields = {};
    const outboundSelectedValues = {};
    
    console.log('convertOutboundRulesToSimplifiedFormat - Input rules:', outboundRules);
    
    outboundRules.forEach(rule => {
      // Normalize workspace_id to match the format from combined workspace API
      // The API returns workspace_id as a number, so convert to number for consistency
      const workspaceId = typeof rule.workspace_id === 'string' 
        ? parseInt(rule.workspace_id) 
        : rule.workspace_id;
      
      if (!workspaceId) return;
      
      console.log('Processing rule - original:', rule.workspace_id, 'type:', typeof rule.workspace_id, 'normalized:', workspaceId, 'type:', typeof workspaceId);
      
      // Add workspace ID to array (now normalized as number)
      outboundSelectedWorkspaces.push(workspaceId);
      
      // Extract selected parsed fields from voice_branch
      let selectedFields = [];
      
      if (rule.voice_branch) {
        const branches = rule.voice_branch
          .split(',')
          .map(b => b.trim())
          .filter(b => b);
        
        // Check if "anybranch" exists in voice_branch
        const hasAnyBranch = branches.includes('anybranch');
        
        // Get specific fields (excluding anybranch)
        const specificFields = branches.filter(b => b !== 'anybranch');
        
        // Build selected fields array
        if (hasAnyBranch) {
          selectedFields = ['anyparsefield', ...specificFields];
        } else {
          selectedFields = specificFields;
        }
      }
      
      // Fallback to 'anyparsefield' only if no fields at all
      if (selectedFields.length === 0) {
        selectedFields = ['anyparsefield'];
      }
      
      console.log('Extracted parsed fields:', selectedFields);
      
      outboundSelectedParsedFields[workspaceId] = selectedFields;
      
      // Extract selected values from branch_values
      const fieldValues = {};
      if (rule.branch_values && Array.isArray(rule.branch_values)) {
        rule.branch_values.forEach(bv => {
          if (bv.key && bv.values) {
            fieldValues[bv.key] = bv.values;
          }
        });
      }
      
      console.log('Extracted field values:', fieldValues);
      
      outboundSelectedValues[workspaceId] = fieldValues;
    });
    
    const result = {
      outboundSelectedWorkspaces,
      outboundSelectedParsedFields,
      outboundSelectedValues
    };
    
    console.log('convertOutboundRulesToSimplifiedFormat - Result:', result);
    
    return result;
  };

  // Outbound workspace dropdown options
  outboundWorkspaceOptionList = () => {
    const workspaces = this.state.outboundWorkspaces || [];
    return workspaces.map((ws) => ({
      key: ws.workspace_id,
      text: ws.workspace_name,
      value: ws.workspace_id
    }));
  };

  // Handle workspace selection
  handleOutboundWorkspaceSelection = (e, d) => {
    this.setState({ 
      outboundSelectedWorkspaces: d.value,
      buttonDisable: false 
    }, () => {
      this.setState({ modalmessage: this.memberEditBody() });
    });
  };

  // Get parsed fields for selected workspaces
  getOutboundParsedFieldsForWorkspace = (workspaceId) => {
    const workspaces = this.state.outboundWorkspaces || [];
    const workspace = workspaces.find(ws => ws.workspace_id === workspaceId);
    return workspace?.parsed_fields || [];
  };

  // Handle parsed field selection for a workspace
  handleOutboundParsedFieldSelection = (workspaceId, fieldKeys) => {
    this.setState(prevState => ({
      outboundSelectedParsedFields: {
        ...prevState.outboundSelectedParsedFields,
        [workspaceId]: fieldKeys
      },
      buttonDisable: false
    }), () => {
      this.setState({ modalmessage: this.memberEditBody() });
    });
  };

  // Handle field value selection (updated to match the naming)
  handleOutboundFieldValueSelection = (workspaceId, fieldKey, values) => {
    this.setState(prevState => ({
      outboundSelectedValues: {
        ...prevState.outboundSelectedValues,
        [workspaceId]: {
          ...(prevState.outboundSelectedValues[workspaceId] || {}),
          [fieldKey]: values
        }
      },
      buttonDisable: false
    }), () => {
      this.setState({ modalmessage: this.memberEditBody() });
    });
  };

  // Convert simplified state to API format for submission
  convertOutboundRulesToApiFormat = () => {
    return this.state.outboundSelectedWorkspaces.map(workspaceId => {
      const selectedFields = this.state.outboundSelectedParsedFields[workspaceId] || [];
      const selectedValues = this.state.outboundSelectedValues[workspaceId] || {};
      
      // Filter out "anyparsefield" for API submission
      const actualFields = selectedFields.filter(f => f !== 'anyparsefield');
      
      const keyIndices = actualFields.map((fieldKey, index) => ({
        key: fieldKey,
        index
      }));
      
      const branchValues = actualFields
        .filter(fieldKey => selectedValues[fieldKey]?.length)
        .map((fieldKey, index) => ({
          key: fieldKey,
          values: selectedValues[fieldKey],
          index
        }));
      
      // Only include "anybranch" if user selected "Any Parse Field"
      const includeAnyBranch = selectedFields.includes('anyparsefield');
      const voiceBranch = includeAnyBranch 
        ? ["anybranch", ...actualFields].join(",")
        : actualFields.join(",");
      
      return {
        workspace_id: workspaceId,
        voice_branch: voiceBranch,
        key_indices: keyIndices,
        branch_values: branchValues,
        values_indices: branchValues
      };
    });
  };

  editMember = async (id) => {
    this.setState({ loading: true });
    
    // Check if this is an outbound member
    const isOutbound = this.state.ai_voice_type === 'outbound';
    
    if (isOutbound) {
      // Handle outbound member editing
      try {
        // Fetch member data from API or fallback to list data
        const rawMemberData = await this.fetchOutboundMemberData(id);
        console.log('Fetched member data:', rawMemberData);
        
        // Normalize member data for form compatibility
        const modaldata = this.normalizeOutboundMemberData(rawMemberData);
        
        // Parse notification preferences
        const notificationPreferences = this.parseNotificationPreferencesFromMemberData(modaldata);
        
        // Fetch outbound workspaces with parsed fields using combined API
        const workspacesResponse = await api.manageUser.getOutboundWorkspacesWithFields();
        const outboundWorkspaces = workspacesResponse?.status && Array.isArray(workspacesResponse.data) 
          ? workspacesResponse.data 
          : [];

        console.log('Edit Mode - Fetched workspaces:', outboundWorkspaces.map(ws => ({
          id: ws.workspace_id,
          type: typeof ws.workspace_id,
          name: ws.workspace_name
        })));

        // Convert outbound_rules to simplified format for the modal
        let simplifiedOutbound = {
          outboundSelectedWorkspaces: [],
          outboundSelectedParsedFields: {},
          outboundSelectedValues: {}
        };

        if (modaldata.outbound_rules && Array.isArray(modaldata.outbound_rules) && modaldata.outbound_rules.length > 0) {
          simplifiedOutbound = this.convertOutboundRulesToSimplifiedFormat(modaldata.outbound_rules);
          console.log('Edit Mode - Converted outbound rules:', simplifiedOutbound);
        }

        // Update state with simplified data
        console.log('Edit Mode - Setting state with outbound data:', {
          outboundWorkspaces: outboundWorkspaces.length,
          simplifiedOutbound
        });
        this.setState({
          modaldata: modaldata,
          modalbuttonmsg: { submit: "Submit", cancel: "Close" },
          modalstatus: true,
          modaltitle: "Edit notification member details",
          modalType: "",
          modalFooter: false,
          notifyvia: notificationPreferences,
          outboundWorkspaces: outboundWorkspaces, // Array with workspace_id, workspace_name, parsed_fields
          ...simplifiedOutbound, // outboundSelectedWorkspaces, outboundSelectedParsedFields, outboundSelectedValues
          loading: false
        }, () => {
          this.setState({
            modalmessage: this.memberEditBody()
          });
        });
      } catch (error) {
        console.error('Error loading outbound member data:', error);
        this.setState({ loading: false });
      }
    } else {
      // Handle inbound member editing (existing logic)
      api.manageUser.getVoiceWorkspaceBranch({}).then((res) => {
        if (res.status) {
          let recordlist = this.state.lists.findIndex((list) => list.id === id);
          let modaldata = {...this.state.lists[recordlist]};
          modaldata.selectedBranchValues=[];
          // modaldata.voice_brances=[];
           modaldata.voice_indices=typeof res?.data?.key_indices!='undefined' ? res?.data?.key_indices : [];
          modaldata.ai_voice_type = this.state.ai_voice_type;
          if (modaldata.email.includes('/')) {
            const phoneEmail = modaldata.email.split('/');
            modaldata.email = phoneEmail[0];
            modaldata.phone = phoneEmail[1];
          }
          const notifi_data = {
            email: false,
            phonecall: false,
            text: false
          };

          modaldata.notify_via.map((item, index) => {
            if (notifi_data.hasOwnProperty(item)) {
              notifi_data[item] = true
            }
          });

            let vals=[];
            if((typeof modaldata.voice_brances !='undefined'  && modaldata.voice_brances.length > 0) && res.data.type=='Turbo') {
              let vlist=modaldata.voice_brances.filter((v)=>v.trim()!=='anybranch' && v.trim()!=='Any branch');
              vals=vlist.map((branch,i)=>{
                    if(branch!=='anybranch' && branch!=='Any branch'){
                      let s=res.data.parsed_values.filter((vall,i,arr)=>{
                          return vall['key']===branch;
                      });
                    return  s;
                    }
              });
            }else{
              vals=[];
            }
            if(vals.length==1 && typeof vals[0]!='undefined' && ( vals[0]=='' || vals[0].length==0)){
              vals=[];
            }
          modaldata.selectedBranchValues=vals;
          let newops=[];
          try {
            if(this.state.voice_type){
              console.log("point 1")
              let ops=res.data.data;
            let brs=modaldata.voice_brances;
            
            for(let k=0;k<brs.length;k++){
                let fri=ops.filter(op=>op.branch_name.includes(brs[k]) && op.branch_name.includes(","));
                if(fri.length>0){
                  newops.push(fri[0].branch_name);
                  if(typeof  brs[k+1]!='undefined'){
                    delete brs[k+1];
                  }
                  
                }else{
                  console.log("point 2")
                  newops.push(brs[k]);
                }
            }
            newops=newops.filter(br=>typeof br!='undefined');
            }else{
              console.log("point 3")
              newops=modaldata.voice_brances;
            }
            
          } catch (error) {
            console.log("point 4");
            newops=modaldata.voice_brances;
          }
          console.log("point 5",newops);
          newops= newops.filter((value, index, array)=> {
            return array.indexOf(value) === index;
          }
          );
          
          this.setState({
            modaldata: modaldata,
            modalbuttonmsg: { submit: "Submit", cancel: "Close" },
            modalstatus: true,
            modaltitle: "Edit notification member details",
            modalType: "",
            modalFooter: false,
            notifyvia: notifi_data,
            workspaceId: res.data.workspaceId,
            workspaceBranches: res.data.data,
            selectedBranch: newops,
            selectedAnswers:modaldata.branch_values,
            parsed_values:res.data.parsed_values,
            voice_type:res.data.type,
            loading: false
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
           
          });
        }
      })
    }
  }

  deleteCompletedChat = (id, table) => {
    let recordlist = this.state.lists.findIndex((list) => list.id === id);
    let modaldata = this.state.lists[recordlist];
    modaldata.ai_voice_type = this.state.ai_voice_type;
    this.setState({
      modalstatus: true,
      modaltitle: "Confirm your action",
      modalmessage: "Are you sure you want to delete?",
      modalbuttonmsg: { submit: "Yes", cancel: "No" },
      modalType: "Delete",
      modaldata: modaldata,
    });
  };

  setCurrentCheck = (checked) => {
    this.setState({
      currentChecked: checked,
    });
  };
  setCurrentExpand = (checked) => {
    this.setState({
      currentExpanded: checked,
    });
  };

  modalClose = (flag, fm) => {
    this.setState({
      modalstatus: false,
      modalstatusAddEdit: false,
      modaltitle: "",
      modalmessage: "",
      modalbuttonmsg: {},
      modalType: "",
      modaldata: {},
      selectedOptions: [],
      modalFooter: true,
      notifyviaError: false,
      notifyviaError1: false,
      selectedBranchValues:[],
      outboundWorkspaces: [],
      outboundSelectedWorkspaces: [],
      outboundSelectedParsedFields: {},
      outboundSelectedValues: {},
    });
  };

  onValidSubmitMember = async () => {
    const isOutbound = this.state.ai_voice_type === 'outbound';

    if (!this.state.modaldata.notify_via || !this.state.modaldata.notify_via.length) {
      this.setState({
        notifyviaError: true
      }, () => {
        this.setState({
          modalmessage: this.memberEditBody()
        })
      });
      return;
    }
    let selbranch=this.state.selectedBranch ?? [];
    selbranch=selbranch?.length===1 && selbranch[0]?.trim()==='' ? []:selbranch;
    
    if (selbranch.length===0) {
      this.setState({
        notifyviaError1: true
      }, () => {
        this.setState({
          modalmessage: this.memberEditBody()
        })
      });
      return;
    }
    this.setState({
      loading: true,
      buttonDisable: true
    }, () => {
      this.setState({
        modalmessage: this.memberEditBody()
      })
    });
    
    // Prepare the payload
    const payload = {...this.state.modaldata};
    
    // For outbound, convert form data to API structure
    if (isOutbound) {
      // Convert workspace rules to API format using simplified conversion
      const outboundRules = this.convertOutboundRulesToApiFormat();
      
      // Build final payload
      payload.outbound_rules = outboundRules;
      payload.isd_code = payload.country_code || payload.isd_code;
      payload.ai_voice_type = 'outbound';
      
      // Ensure id is included for update operations
      if (!payload.id && this.state.modaldata.id) {
        payload.id = this.state.modaldata.id;
      }
      
      // Remove fields not needed by API
      delete payload.outboundWorkspaceRules;
      delete payload.selectedBranchValues;
      
      api.manageUser.updateOutboundNotificationMember(payload).then((res) => {
      this.setState({ loading: false, buttonDisable: false })
      // Handle both res.data and res response structures
      const responseData = res.data || res;
      console.log("responseData from updateOutboundNotificationMember",responseData);
      if (responseData.status) {
        this.setState({
          messageDisplay: 'block',
          color: 'green',
          resMessage: responseData.message || 'Member updated successfully.'
        }, () => {
          this.setState({
            modalmessage: this.memberEditBody()
          });
        });
        setTimeout(() => {
          this.setState({
            messageDisplay: 'none'
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
          });
          if(responseData.status){
            this.loadData({});
            this.modalClose(false, "");
            // Notify parent component to reload TimeZone and ScheduleCalendar
            if (this.props.onMemberUpdated) {
              this.props.onMemberUpdated();
            }
          } else if(responseData.error === "duplicate") {
            // Close modal for duplicate errors too
            this.modalClose(false, "");
          }
        }, 2000);
      } else {
        this.setState({
          messageDisplay: 'block',
          color: 'red',
          resMessage: responseData.message || 'Failed to update member. Please try again.'
        }, () => {
          this.setState({
            modalmessage: this.memberEditBody()
          });
        });
        setTimeout(() => {
          this.setState({
            messageDisplay: 'none'
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
          });
        }, 3000);
      }
    }).catch((err) => {
      console.error('Update outbound notification member error:', err);
      this.setState({ 
        loading: false, 
        buttonDisable: false,
        messageDisplay: 'block',
        color: 'red',
        resMessage: err.response?.data?.message || err.message || 'An error occurred while updating the member. Please try again.'
      }, () => {
        this.setState({
          modalmessage: this.memberEditBody()
        });
      });
      setTimeout(() => {
        this.setState({
          messageDisplay: 'none'
        }, () => {
          this.setState({
            modalmessage: this.memberEditBody()
          });
        });
      }, 3000);
    });
    } else {
      // Inbound logic
      payload.ai_voice_type = 'inbound';
      api.manageUser.updateNotificationMember(payload).then((res) => {
        this.setState({ loading: false, buttonDisable: false })
        if (res.data.status) {
          this.setState({
            messageDisplay: 'block',
            color: 'green',
            resMessage: res.data.message
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
          });
        } else {
          this.setState({
            messageDisplay: 'block',
            color: 'red',
            resMessage: res.data.message
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
          });
        }
        setTimeout(() => {
          this.setState({
            messageDisplay: 'none'
          }, () => {
            this.setState({
              modalmessage: this.memberEditBody()
            });
          });
          if(res.data.error!=="duplicate" && res.data.status){
            this.loadData({});
            this.modalClose(false, "");
            // Notify parent component to reload TimeZone and ScheduleCalendar
            if (this.props.onMemberUpdated) {
              this.props.onMemberUpdated();
            }
          }
         
        }, 2000);
      }).catch((err) => {
        console.log(err);
        this.setState({ loading: false, buttonDisable: false });
      });
    }
  }
  handleSpecialchar(txt){
    //let list=this.branchOptionList();
   
    // if(typeof txt=='object' && txt.length>0){
    //   txt=txt.join(",");
    // }
    // console.log(txt,"after");
    return txt;
  }

  phoneFormat = (p) => {
    p = p.replace(/[^\d]*/gi, "");
    if (p.length <= 3) {
      return p;
    } else if (p.length > 3 && p.length < 7) {
      p = "(" + p;
      let l30 = p.length;
      let p30 = p.substring(0, 4);
      p30 = p30 + ")";

      let p31 = p.substring(4, l30);
      let pp = p30 + p31;
      return pp;
    } else if (p.length >= 7) {
      p = "(" + p;
      let l30 = p.length;
      let p30 = p.substring(0, 4);
      p30 = p30 + ")";

      let p31 = p.substring(4, l30);
      let pp = p30 + p31;

      let l40 = pp.length;
      let p40 = pp.substring(0, 8);
      p40 = p40 + "-";

      let p41 = pp.substring(8, l40);
      let ppp = p40 + p41;
      let maxphonelength = 13;
      let finalPhone = ppp.substring(0, maxphonelength);
      return finalPhone;
    }
  };

  handlePhonePaste = (e) => {
    e.preventDefault();
    const memberData = this.state.modaldata;
    let digits = e.clipboardData.getData("text").replace(/\D/g, "").substring(0, 10);
    let p = this.phoneFormat(digits);
    memberData.phone = p;
    this.setState({ modaldata: memberData, email1: "", disableBtn: false }, () => {
      this.setState({ modalmessage: this.memberEditBody() });
    });
  };

  handlePhoneChange = (e) => {
    const memberData = this.state.modaldata;
    let digits = e.target.value.replace(/\D/g, "").substring(0, 10);
    let p = this.phoneFormat(digits);
    e.target.value = p;
    memberData.phone = p;
    this.setState({ modaldata: memberData, email1: "", disableBtn: false }, () => {
      this.setState({ modalmessage: this.memberEditBody() });
    });
  };

  handleChangeISD = (e) => {
    const memberData = this.state.modaldata;
    memberData.country_code = e.target.value;
    this.setState({
      modaldata: memberData,
    }, () => {
      this.setState({
        modalmessage: this.memberEditBody()
      })
    });
  };

  memberEditBody = () => {
    console.log("name", this.state.modaldata.name);
    const errorLabel = <div className="red" />;
    return (
      <div className="col-md-12">
        <Message
          color={this.state.color}
          style={{
            display: this.state.messageDisplay,
          }}
        >
          {this.state.resMessage}
        </Message>
        <Form
          noValidate
          autoComplete="off"
          className="manageNotificationIndiviNoti"
          id="manageNotificationIndiviNoti"
          onValidSubmit={this.onValidSubmitMember}
        >
          <div className="form-group">
            <label style={{ marginBottom: 0 }}>Full Name</label>
            <Form.Input
              type="text"
              className="1"
              name="name"
              validations="isRequired"
              validationErrors={{
                isRequired: "This field is required.",
              }}
              onChange={this.onchangeenable}
              errorLabel={errorLabel}
              defaultValue={this.state.modaldata.name}
            />            
          </div>
          <div
            className="form-group"
            style={{ marginBottom: 10 }}
          >
            <label style={{ marginBottom: 0 }}>
              Email Address
            </label>
            {this.state.notifyvia.email ?
              <Form.Input
                type="email"
                className=""
                name="email"
                validations="isEmail,isRequired"
                validationErrors={{
                  isEmail:
                    "Please enter a valid email address.",
                  isRequired: "This field is required.",
                }}
                errorLabel={errorLabel}
                onChange={this.onchangeenable}
                id="emailIndiviNoti"
                defaultValue={this.state.modaldata.email}
              /> :
              <Form.Input
                type="email"
                className=""
                name="email"
                errorLabel={errorLabel}
                onChange={this.onchangeenable}
                id="emailIndiviNoti"
                defaultValue={this.state.modaldata.email}
              />
            }
          </div>
          {(
          <div
            className="form-group"
            style={{ marginBottom: 10 }}
          >
            <label>Phone Number</label>
            <div className="d-flex">
              <select
                class="form-control"
                name="country_code"
                id="isd_code"
                onChange={this.handleChangeISD}
                style={{ maxWidth: 166, marginRight: "1rem" }}
                defaultValue={this.state.modaldata.country_code || this.state.modaldata.isd_code || '+1'}
              >
                {this.renderDropDownDefault(
                  this.props.ISDrenderOption1
                )}
                <optgroup label="Other countries">
                  {this.renderDropDownRemaining(
                    this.props.ISDrenderOption2
                  )}
                </optgroup>
              </select>
              {(this.state.notifyvia.text || this.state.notifyvia.phonecall) ?
                <Form.Input
                  fluid
                  autoComplete="off"
                  name="phone"
                  maxLength="13"
                  value={this.state.modaldata.phone}
                  onPaste={this.handlePhonePaste}
                  onChange={this.handlePhoneChange}
                  placeholder="Phone Number"
                  validations="isRequired,usPhoneLength"
                  validationErrors={{
                    isRequired: "This field is required.",
                    usPhoneLength:
                      "Phone number must be at least 10 numbers.",
                  }}
                  id="phoneNumberIndiviNoti"
                  className="w-100"
                  errorLabel={errorLabel}
                /> :
                <Form.Input
                  fluid
                  autoComplete="off"
                  name="phone"
                  maxLength="13"
                  value={this.state.modaldata.phone}
                  onPaste={this.handlePhonePaste}
                  onChange={this.handlePhoneChange}
                  placeholder="Phone Number"
                  id="phoneNumberIndiviNoti"
                  className="w-100"
                  errorLabel={errorLabel}
                />
              }
            </div>
          </div>
          )}
          <div className="row form-group" style={{ marginBottom: 10 }}>
            <div className="col-md-6">
              <div className="form-group">
                <label>Notification Type</label>
                <select className="form-control" name="notification_type" onChange={this.onchangeenable} defaultValue={this.state.modaldata.notification_type}>
                  <option value="1">All notifications</option>
                  <option value="2">Schedule based</option>
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <label>Notify via</label>
              <div style={{ display: 'flex', columnGap: 10 }}>
                <Checkbox
                  name="notifyvia"
                  // value={1} 
                  label={{ children: 'Email' }}
                  onChange={() => this.changeNotifyVia('email')}
                  defaultChecked={this.state.modaldata?.notify_via?.includes('email')}
                />
                <Checkbox name="notifyvia" label={{ children: 'Text' }} onChange={() => this.changeNotifyVia('text')} defaultChecked={this.state.modaldata?.notify_via?.includes('text')} />
                {!this.props.isPLG && <Checkbox name="notifyvia" label={{ children: 'Phone Call' }} onChange={() => this.changeNotifyVia('phonecall')} defaultChecked={this.state.modaldata?.notify_via?.includes('phonecall')} />}
              </div>

              {this.state.notifyviaError && <div class="red">This field is required.</div>}
            </div>
          </div>
          {/* Outbound Workspace Rules - Simplified Approach */}
          {this.state.ai_voice_type === 'outbound' && (
            <>
              <div className="form-group mt-2">                
                
                <div className="row">
                  <div className="form-group col-md-6 mt-2">
                    <label style={{ fontSize: '14px' }}>Select Outbound Workspaces</label>
                    <Dropdown
                      placeholder='Select Workspaces'
                      fluid
                      multiple
                      search
                      selection
                      options={this.outboundWorkspaceOptionList()}
                      value={this.state.outboundSelectedWorkspaces}
                      onChange={this.handleOutboundWorkspaceSelection}
                    />
                  </div>
                </div>
                
                {/* Show parsed fields for each selected workspace */}
                {this.state.outboundSelectedWorkspaces.map(workspaceId => {
                  const workspace = (this.state.outboundWorkspaces || [])
                    .find(ws => ws.workspace_id === workspaceId);
                  const parsedFields = this.getOutboundParsedFieldsForWorkspace(workspaceId);
                  
                  // Always show workspace section, even if no parsed fields
                  const parsedFieldOptions = [
                    { key: 'anyparsefield', text: 'Any Parse Field', value: 'anyparsefield' }
                  ];
                  
                  if (parsedFields && parsedFields.length > 0) {
                    parsedFields.forEach(field => {
                      parsedFieldOptions.push({
                        key: field.key,
                        text: field.key,
                        value: field.key
                      });
                    });
                  }
                  
                  return (
                    <React.Fragment key={workspaceId}>
                      <div className="row">
                        <div className="form-group col-md-6 mt-2">
                          <label>
                            Parsed Fields for <span style={{ color: '#2185d0' }}> {workspace?.workspace_name} </span>
                          </label>
                          <Dropdown
                            fluid
                            multiple
                            search
                            selection
                            placeholder="Select Parsed Data"
                            options={parsedFieldOptions}
                            value={this.state.outboundSelectedParsedFields[workspaceId] || ['anyparsefield']}
                            onChange={(e, { value }) => 
                              this.handleOutboundParsedFieldSelection(workspaceId, value)
                            }
                          />
                        </div>
                      
                        {/* Show value dropdowns for selected fields */}
                        {(this.state.outboundSelectedParsedFields[workspaceId] || []).map(fieldKey => {
                          // Skip "anyparsefield" as it doesn't have values
                          if (fieldKey === 'anyparsefield') return null;
                          
                          const field = parsedFields.find(f => f.key === fieldKey);
                          if (!field?.values?.length) return null;
                          
                          return (
                            <div key={fieldKey} className="form-group col-md-6 mt-2">
                              <label>
                                Values for <span style={{ color: '#2185d0' }}>{fieldKey}</span>
                              </label>
                              <Dropdown
                                fluid
                                multiple
                                search
                                selection
                                placeholder={`Select ${fieldKey}`}
                                options={field.values.map(val => ({
                                  key: val,
                                  text: val,
                                  value: val
                                }))}
                                value={this.state.outboundSelectedValues[workspaceId]?.[fieldKey] || []}
                                onChange={(e, { value }) =>
                                  this.handleOutboundFieldValueSelection(workspaceId, fieldKey, value)
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

            </>
          )}

          {/* For inbound/Turbo, show the existing "Notify if call goes through" dropdown */}
          {this.state.ai_voice_type !== 'outbound' && (
            <div className="form-group">
              <label>Notify if call goes through</label>
              <Dropdown
                placeholder=''
                fluid
                multiple
                search
                selection
                options={this.branchOptionList()}
                value={this.state.selectedBranch && this.state.selectedBranch.length > 0 
                  ? this.state.selectedBranch.map(sb => String(sb))
                  : ['anybranch']}
                onChange={this.handleBranchSelection}
              />
              {this.state.notifyviaError1 && <div class="red">This field is required.</div>}
            </div>
          )}

          {/* Show branch values for inbound/Turbo only */}
          {this.state.ai_voice_type !== 'outbound' && (
            <div style={{marginTop:'20px',marginBottom:'30px'}}>
              {(this.state.voice_type=='Turbo' && 
                ((this.state.modaldata?.selectedBranchValues?.length>0 && this.state.modaldata?.voice_brances?.length>0))) && 
                <div className="row">
                    {(this.state.modaldata?.selectedBranchValues && this.state.modaldata.selectedBranchValues.length > 0 
                      ? this.state.modaldata.selectedBranchValues 
                      : []).map((item,i)=>{
                      let ans=[];
                      let values=[];
                      
                      if(item && item!=='' && item[0]){
                         let branchvals=this.state.modaldata?.branch_values && this.state.modaldata?.branch_values!=='undefined' ? this.state.modaldata?.branch_values :[];
                        ans=branchvals.filter((it)=>it.key===item[0]?.key);
                        if(ans.length>0){
                          values=ans[0]?.values;
                       }else{
                         values=[];
                       }
                        const hasValues = item[0]?.val && Array.isArray(item[0].val) && item[0].val.length > 0;
                        
                        if (hasValues && item[0]?.key) {
                          return( <div style={{width:'100%'}} key={`branch-value-${i}-${item[0]?.key}`}>{(typeof item[0]!=='undefined' && typeof item[0].key!=='') ? <div  className="form-group col-md-6" key={item[0]?.key}>
                            <label>Branch Value for {item[0]?.key}</label>
                                 <Dropdown
                                   key={item[0]?.key}
                                   name={item[0]?.key}
                                   placeholder='Select values'
                                   fluid
                                   multiple
                                   search
                                   selection
                                   options={this.branchansList(item)}
                                   defaultValue={values}
                                   onChange={this.handleAnswerSelection}
                                 />
                            </div>:<></>}</div> );
                        }
                      }
                      return null;
                    })} 
                </div>
              }
            </div>
          )}

          <div className="form-group">
            <label style={{ marginBottom: 0 }}>Include Unique Identifier</label>
            <input
              type="text"
              className="form-control"
              name="user_notification_values"              
              onChange={this.onchangeenable}              
              defaultValue={this.state.modaldata.user_notification_values}
            />
            <small>This value will be passed in a webhook payload if the user is notified - Webhook field will be "user_notification_values"</small>
          </div>

          <div className="form-group" style={{ display: 'flex', marginTop: 10, columnGap: 10, justifyContent: 'right' }}>
            <button
              type="button"
              onClick={() => this.modalClose(false, "")}
              style={{ display: this.state.modalbuttonmsg.cancel != "" ? "block" : "none" }}
              className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
              data-dismiss="modal"
            >
              <span>Close</span>
            </button>
            <button
              disabled={this.state.buttonDisable}
              type="submit"
              // onClick={() => this.modalbuttofun(this.state.modalType)}
              style={{ display: this.state.modalbuttonmsg.submit != "" ? "block" : "none" }}
              className="btn linear-gradient yr-submitbtn btn-sm"
            >
              Submit
            </button>
          </div>
        </Form>
      </div>
    )
  }

  changeNotifyVia = (fieldname) => {
    const memberData = this.state.modaldata;
    let notifyData = memberData.notify_via;
    if (!notifyData.includes(fieldname)) {
      notifyData.push(fieldname);
    } else {
      const findIndex = notifyData.findIndex((v, i) => v == fieldname);
      if (findIndex !== -1) {
        notifyData.splice(findIndex, 1);
      }
    }
    memberData.notify_via = notifyData;
    const notifyvia = this.state.notifyvia;
    notifyvia[fieldname] = !notifyvia[fieldname];
    this.setState({
      modaldata: memberData,
      notifyvia: notifyvia,
      notifyviaError: false,
      notifyviaError1:false
    }, () => {
      this.setState({
        modalmessage: this.memberEditBody()
      })
    })
  }

  // Outbound workspace rules handlers
  fetchOutboundWorkspaceParsedFields = async (workspaceId) => {
    try {
      const res = await api.manageUser.getOutboundWorkspacesWithFields();
      if (res?.status && Array.isArray(res.data)) {
        const workspace = res.data.find(ws => String(ws.workspace_id) === String(workspaceId));
        return workspace?.parsed_fields || [];
      }
      return [];
    } catch (e) {
      console.error('Error fetching outbound workspace parsed fields:', e);
      return [];
    }
  };

  renderDropDownDefault = (defaultCountryCodeArr, countryId = null) => {
    return defaultCountryCodeArr.map((option, index) => {
      return (
        <option
          key={index}
          value={option.country_code}
          selected={countryId == option.country_code ? "selected" : ""}
        >
          {option.country_name}
        </option>
      );
    });
  };

  renderDropDownRemaining = (remailCountryCodeArr, countryId = null) => {
    return remailCountryCodeArr.map((option, index) => {
      return (
        <option
          key={index}
          value={option.country_code}
          selected={countryId == option.country_code ? "selected" : ""}
        >
          {option.country_name}
        </option>
      );
    });
  };

  onchangeenable = (e) => {
    const memberData = this.state.modaldata;
    memberData[e.target.name] = e.target.value;
    this.setState({
      modaldata: memberData,
    }, () => {
      this.setState({
        modalmessage: this.memberEditBody()
      })
    });
  }

  reloadDataTable = () => {
    // Preserve ai_voice_type when reloading to ensure correct data filtering
    this.loadData({});
  };
  onDeleteCompletedChatAction = () => {
    this.setState({ modalFormLoader: true });
    const isOutbound = this.state.ai_voice_type === 'outbound';
    
    // Use the same deleteVoiceListMember API for both inbound and outbound
    const deletePayload = {
      id: this.state.modaldata.id,
    };
    
    // Add table for inbound if available
    if (!isOutbound && this.state.modaldata.table) {
      deletePayload.table = this.state.modaldata.table;
    }
    
    api.manageUser.deleteVoiceListMember(deletePayload).then((data) => {
        this.setState({ modalFormLoader: false });
        try {
          const deletedId = data?.data?.id || this.state.modaldata.id;
          
          let recordDeleted = this.state.lists.findIndex(
            (list) => list.id === deletedId
          );
          
          if (recordDeleted !== -1) {
            let oldArr = [...this.state.lists];
            oldArr.splice(recordDeleted, 1);
            this.setState({
              lists: oldArr,
            });
          }

          // Close modal and show success message
          this.setState({
            modalstatus: false,
            modaltitle: "",
            modalmessage: "",
            modalbuttonmsg: {},
            modalType: "",
            modaldata: {},
            modalErrorMsg: false,
            loading: false,
            message2: "block",
            color2: "green",
            msg2: "Ai phone call notification member has been deleted successfully.",
          });
          this.props.UpdateToasterMsgThree(this.state);
          // Always reload data to ensure UI is in sync with backend
          this.loadData({});
          // Notify parent component to reload TimeZone and ScheduleCalendar
          if (this.props.onMemberUpdated) {
            this.props.onMemberUpdated();
          }
        } catch (err) {
          console.log('Error handling delete response:', err);
          // Close modal even on error
          this.setState({
            modalstatus: false,
            modaltitle: "",
            modalmessage: "",
            modalbuttonmsg: {},
            modalType: "",
            modaldata: {},
            modalErrorMsg: false,
            modalFormLoader: false
          });
          // Even if there's an error, reload data to ensure consistency
          this.loadData({});
          // Notify parent component even on error
          if (this.props.onMemberUpdated) {
            this.props.onMemberUpdated();
          }
        }
      }).catch((err) => {
        console.error('Delete API error:', err);
        // Close modal on error
        this.setState({ 
          modalFormLoader: false,
          modalstatus: false,
          modaltitle: "",
          modalmessage: "",
          modalbuttonmsg: {},
          modalType: "",
          modaldata: {},
          modalErrorMsg: false
        });
        // Reload data even on error to ensure consistency
        this.loadData({});
        // Notify parent component even on error
        if (this.props.onMemberUpdated) {
          this.props.onMemberUpdated();
        }
      });
  };

  loadData = (params = {}) => {
    // Ensure ai_voice_type is preserved from state, not overridden by params
    const ai_voice_type = this.state.ai_voice_type || this.props.ai_voice_type || 'inbound';
    
    const newState = Object.assign({}, this.state, params, { loading: false });
    queryParams.forEach(function (element) {
      if (!(element in params)) {
        params[element] = newState[element];
      }
    });

    // Always use the state's ai_voice_type to ensure correct filtering
    // This prevents data mixing between inbound and outbound
    params["ai_voice_type"] = ai_voice_type;

    // let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
    // let clientTimeZone = u.substring(0, 3) + ":" + u.substring(3, u.length);
    // let time_zone = clientTimeZone;

    // params["time_zone"] = time_zone;

    const esc = encodeURIComponent;
    const query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    let totalCountQuery = "";
    if (params.q !== "") {
      totalCountQuery = `q=${params.q}`;
    }
    this.setState(newState, () => {
      this.setState({ loading: true });
      api.manageUser.getVoiceLists(query).then((data) => {
        try {
          // let accessModuleStore = data.user_access;
          // data.user_access.forEach((item, index) => {
          //   item.forEach((item2, index2) => {
          //     accessModuleStore.push(item2);
          //   });
          // });
          let datatableRowstemp;
          var isd1 = "+1";
          var phoneno = "";
          var is_recieve_text_message_on_livechat = "0";
          var is_recieve_email_on_livechat = "0";
          var jumpin_message = "";
          var is_recieve_text_message_on_completechat = "0";
          var is_recieve_email_on_completechat = "0";
          var is_leave_note = "0";
          if (data.data.totalrecord) {
            datatableRowstemp = data.data.list.map((list, index) => (
              <DatatableRow
                key={index}
                list={list}
                editUserSubAccounts={this.editUserSubAccounts}
                deleteHipaaUserSubAccounts={this.deleteHipaaUserSubAccounts}
                preOpensetting={this.preOpensetting}
                sessionUser={this.props.sessionUser}
                deleteCompletedChat={this.deleteCompletedChat}
                editMember={this.editMember}
                isPLG={this.props.isPLG}
                ai_voice_type={this.state.ai_voice_type}
              />
            ));
          } else {
            datatableRowstemp = (
              <Table.Row>
                <Table.Cell colSpan={7} textAlign="center">
                  No record found.
                </Table.Cell>
              </Table.Row>
            );
          }
          this.setState({
            datatableRows: datatableRowstemp,
            totalCount: data.data.totalrecord,
            lists: data.data.list,
          });
        } catch (err) {
          console.log(err);
        }
        const newState = Object.assign({}, this.state, params, {
          loading: false,
        });
        this.setState(newState);
      });
    });
  };

  render() {
    return (
      <Segment>
        {this.state.loading && <div className="ui loading form"></div>}
        <DatatableFilter
          filter={this.state.q}
          totalCount={this.state.totalCount}
          onSubmitFilter={this.onSubmitFilter}
          loading={this.state.loading}
        />
        <DialogBoxDetail
          obj={this.state}
          show={this.state.modalstatus}
          title={this.state.modaltitle}
          message={this.state.modalmessage}
          modalType={this.state.modalType}
          modalClose={this.modalClose}
          buttonmsg={this.state.modalbuttonmsg}
          modalbuttofun={this.modalbuttofun}
          loading={this.state.loading}
          currentChecked={this.state.currentChecked}
          currentExpanded={this.state.currentExpanded}
          setCurrentCheck={this.setCurrentCheck}
          setCurrentExpand={this.setCurrentExpand}
          modalFooter={this.state.modalFooter}

        />
        <DatatableTable
          lists={this.state.lists}
          datatableHeader={tableHeader}
          datatableRows={this.state.datatableRows}
          totalCount={this.state.totalCount}
          totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
          currentPage={this.state._page}
          onChangePage={this.onChangePage}
          column={this.state._sort}
          direction={DatatableList.directionConverter(this.state._order)}
          handleSort={this.handleSort}
          onChangeLimit={this.onChangeLimit}
          limit={this.state._limit.toString()}
        />
      </Segment>
    );
  }
}

const mapStateToProps = (state) => ({
  isPLG: selectIsPLGAccount(state),
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(DatatableList);
